import { initializeHeaderWithUserInfo } from "./header";
// import { getAllExistingSejStores, EXISTING_SEJ_STORES_RECORD } from "../data/existingSejStores"
import { loadProjectDataFromApi } from "../data/projectData";
import { DEFAULT_PAGE_SIZE } from "../constant/applicationConstant";
import { getHtml } from "../apis/templateHtml";
import { navigate } from "../router/router";
import { postRequest } from "../apis/axiosAction";
import { ColumnManager } from "../modules/columnManager/ColumnManager";
import { getUserInformationCached } from "../modules/userManager/UserManager";
import { generateProjectRoute } from "../constant/businessTypeConstants";
import { startLoadingDisplay, endLoadingDisplay } from "../modules/uiManager/UiLoadingDisplay";
import { loadZoDataFromApi, loadDoDataFromApi } from "../data/zodoData";
import { setSelectZo } from "../search/SearchZO";
import { setSelectDo } from "../search/SearchDO";
import { showPopupAlert } from "../modules/uiManager/UiPopup";
/**
 * CSV出力を実行する関数
 */
async function exportProjectDataToCsv() {
    console.log('CSV出力処理を開始します');
    try {
        // 現在の検索条件を取得（検索処理と同じロジックを使用）
        const searchParams = {
            tenpoNo: checkSearchStoreNo(),
            tenpoName: checkSearchStoreName(),
            zoCode: "",
            zoName: checkSearchZoName(),
            doCode: "",
            doName: checkSearchDoName(),
            ofcName: checkSearchOfcName(),
            projectNo: checkSearchProjectNo(),
            businessType: checkSearchBusinessType(),
            programName: checkSearchProgramName(),
            projectStatus: checkSearchProjectStatus(),
            status: checkSearchStatus(),
            progressStatus: "", // 後方互換性のため保持
            startDateFrom: checkSearchProjectFrom(), // 案件開始日（From）
            startDateTo: checkSearchProjectTo() // 案件開始日（To）
            // CSV出力は常に全カラム出力するため、columnPatternは指定しない（バックエンドでdefaultが使用される）
        };
        // 検索条件の検証エラーがある場合は処理を中断
        if (searchParams.tenpoNo === '' && checkSearchStoreNo() !== searchParams.tenpoNo) {
            return; // 店番の検証でアラートが表示されるため、処理を中断
        }
        if (searchParams.projectNo === '' && checkSearchProjectNo() !== searchParams.projectNo) {
            return; // 案件Noの検証でアラートが表示されるため、処理を中断
        }
        console.log('CSV出力用検索パラメータ:', searchParams);
        // CSV出力APIを呼び出し（ローディング表示付き）
        const domain = process.env.APP_API_URL;
        const url = `${domain}j21spb32/project-export-csv`;
        const response = await postRequest(url, searchParams);
        console.log('CSV出力APIレスポンス:', response);
        // レスポンスの検証とダウンロード実行
        if (response.data && response.data.statusCode === 200 && response.data.data && response.data.data.downloadUrl) {
            const { downloadUrl, fileName, recordCount } = response.data.data;
            console.log(`CSV出力成功: ${recordCount}件のデータを出力します`);
            // ファイルダウンロードを実行
            // ※ファイル名はバックエンドがGCS署名付きURLの response-content-disposition で指定する
            downloadFile(downloadUrl, fileName);
        }
        else {
            // APIレスポンスの構造が期待と異なる場合
            const errorMessage = response.data?.message || 'CSV出力に失敗しました';
            console.error('CSV出力失敗:', errorMessage);
            showPopupAlert({
                text: `CSV出力に失敗しました: ${errorMessage}`,
                showBackdrop: true
            });
        }
    }
    catch (error) {
        console.error('CSV出力エラー:', error);
        // エラーの詳細をログに出力
        if (error instanceof Error) {
            console.error('エラーメッセージ:', error.message);
            console.error('エラースタック:', error.stack);
        }
        // ユーザーにエラーを通知
        showPopupAlert({
            text: 'CSV出力中にエラーが発生しました。しばらく時間をおいて再度お試しください。',
            showBackdrop: true
        });
    }
}
/**
 * ファイルダウンロードを実行する関数
 * GCS署名付きURL（クロスオリジン）を使用するため link.download を設定するとブラウザが
 * CORSフェッチとして扱い、GCSのCORS設定がないとエラーになる。
 * そのため link.download は設定せずナビゲーション扱いでダウンロードさせる。
 * ファイル名はバックエンドがGCSアップロード時に Content-Disposition ヘッダーで指定する。
 */
function downloadFile(url, fileName) {
    try {
        const link = document.createElement('a');
        link.href = url;
        // link.download は設定しない（クロスオリジンURLでCORSエラーになるため）
        // ファイル名はGCSのContent-Dispositionヘッダーから取得される
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        console.log('ファイルダウンロードを実行しました:', fileName);
    }
    catch (error) {
        console.error('ファイルダウンロードエラー:', error);
        showPopupAlert({
            text: 'ファイルのダウンロードに失敗しました。',
            showBackdrop: true
        });
    }
}
/**
 * 署名付きURL取得のリクエストを実行する関数
 */
async function requestSignedUrl() {
    console.log('署名付きURL取得処理を開始します');
    try {
        // 環境変数からデジタルツールのホストアドレスを取得
        const digitalToolsUrl = process.env.DIGITAL_TOOLS_URL || 'https://dev.digital-tools.jp/';
        const apiUrl = `${digitalToolsUrl}j21spb32/v1/storage/signed-url`;
        console.log('API URL:', apiUrl);
        // リクエストパラメータ
        const requestParams = {
            type: "management-dx-manual"
        };
        // POST通信を実行
        const response = await postRequest(apiUrl, requestParams);
        // レスポンスの内容をコンソールに表示
        if (response.data.data) {
            // 成功時の処理
            if (response.data.statusCode === 200 && response.data.data.signedUrl) {
                // 署名付きURLでマニュアルを開く
                window.open(response.data.data.signedUrl, '_blank');
                console.log('マニュアルを新しいタブで開きました');
            }
            else {
                console.error('署名付きURL取得に失敗しました:', response.data.message);
                showPopupAlert({
                    text: `マニュアルの取得に失敗しました: ${response.data.message || '不明なエラー'}`,
                    showBackdrop: true
                });
            }
        }
        else {
            console.error('レスポンスデータが空です');
            showPopupAlert({
                text: 'マニュアルの取得に失敗しました: レスポンスデータが空です',
                showBackdrop: true
            });
        }
    }
    catch (error) {
        console.error('署名付きURL取得エラー:', error);
        // エラーの詳細をログに出力
        if (error instanceof Error) {
            console.error('エラーメッセージ:', error.message);
            console.error('エラースタック:', error.stack);
        }
        // ユーザーにエラーを通知
        showPopupAlert({
            text: 'マニュアルの取得中にエラーが発生しました。しばらく時間をおいて再度お試しください。',
            showBackdrop: true
        });
    }
}
/**
 * 店舗情報リスト
 */
// let tenpoData: EXISTING_SEJ_STORES_RECORD[] = [];
/**
 * 案件情報リスト
 */
let projectData = [];
/**
 * ページング情報
 */
let paginationInfo = {
    page: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    totalRecords: 0,
    totalPages: 0,
    hasNext: false,
    hasPrevious: false
};
/**
 * 列管理インスタンス
 */
let columnManager;
/**
 * テーブルを初期化する関数
 */
async function initializeTable() {
    const tableContainer = document.querySelector('.table-container table');
    if (!tableContainer) {
        console.error('テーブル要素が見つかりません');
        return;
    }
    // ColumnManagerを使用してテーブルHTMLを生成
    const tableHTML = columnManager.generateTableHTML(projectData);
    tableContainer.innerHTML = tableHTML;
    // ドラッグアンドドロップを初期化
    columnManager.initializeDragDrop(tableContainer, (columns) => {
        console.log('列順序が変更されました:', columns);
        updateTable();
        // パネルが開いている場合は更新
        const panel = document.querySelector('.column-settings-panel');
        if (panel && !panel.classList.contains('hidden')) {
            updateColumnSettingsPanel(panel);
        }
    });
    const panel = document.querySelector('.column-settings-panel');
    if (panel) {
        updateColumnSettingsPanel(panel);
    }
    // ColumnManagerで生成されたdata-linkはルーターが自動処理するため、
    // 追加のイベントリスナー設定は不要
}
/**
 * 列設定パネルの表示/非表示を切り替える関数
 */
function toggleColumnSettingsPanel() {
    let panel = document.querySelector('.column-settings-panel');
    if (!panel) {
        panel = createColumnSettingsPanel();
        document.body.appendChild(panel);
    }
    updateColumnSettingsPanel(panel);
    panel.classList.toggle('hidden');
}
/**
 * 列設定パネルを作成する関数
 */
function createColumnSettingsPanel() {
    const panel = document.createElement('div');
    panel.className = 'column-settings-panel hidden';
    updateColumnSettingsPanel(panel);
    return panel;
}
/**
 * 列設定パネルの内容を更新する関数
 */
function updateColumnSettingsPanel(panel) {
    const newHTML = columnManager.generateColumnSettingsPanelHTML();
    panel.innerHTML = newHTML;
    // イベントリスナーを再設定
    setupPanelEventListeners(panel);
    // パネル内ドラッグアンドドロップを再初期化
    columnManager.initializePanelDragDrop(panel, () => {
        updateColumnSettingsPanel(panel);
        updateTable();
        showSaveIndicator();
    });
}
/**
 * パネルのイベントリスナーを設定する関数
 */
function setupPanelEventListeners(panel) {
    // チェックボックスの変更イベント
    const checkboxes = panel.querySelectorAll('.column-checkbox');
    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', handleColumnVisibilityChange);
    });
    // リセットボタン
    const resetButton = panel.querySelector('.reset-button');
    if (resetButton) {
        resetButton.addEventListener('click', handleResetColumns);
    }
    // 閉じるボタン
    const closeButton = panel.querySelector('.close-button');
    if (closeButton) {
        closeButton.addEventListener('click', () => {
            panel.classList.add('hidden');
        });
    }
}
/**
 * 列の表示/非表示変更を処理する関数
 */
function handleColumnVisibilityChange(event) {
    const target = event.target;
    if (target.classList.contains('column-checkbox')) {
        const columnKey = target.dataset.columnKey;
        const visible = target.checked;
        console.log(`チェックボックス変更: ${columnKey}, checked=${visible}`);
        columnManager.toggleColumnVisibility(columnKey, visible);
        // テーブルを再生成
        updateTable();
        // パネルを更新（チェックボックス状態を正しく反映）
        const panel = document.querySelector('.column-settings-panel');
        if (panel && !panel.classList.contains('hidden')) {
            updateColumnSettingsPanel(panel);
        }
        // 保存インジケーターを表示
        showSaveIndicator();
    }
}
/**
 * 列設定をリセットする関数
 */
async function handleResetColumns() {
    await columnManager.resetToDefault();
    // パネルを閉じる
    const panel = document.querySelector('.column-settings-panel');
    if (panel) {
        panel.classList.add('hidden');
    }
    // テーブルを再生成
    await initializeTable();
}
/**
 * 保存インジケーターを表示する関数
 */
function showSaveIndicator() {
    const indicator = document.querySelector('.save-indicator');
    if (indicator) {
        indicator.classList.add('visible');
        setTimeout(() => {
            indicator.classList.remove('visible');
        }, 2000);
    }
}
/**
 * テーブルを更新する関数
 */
function updateTable() {
    const tableContainer = document.querySelector('.table-container table');
    if (tableContainer && columnManager) {
        const tableHTML = columnManager.generateTableHTML(projectData);
        tableContainer.innerHTML = tableHTML;
        // ドラッグアンドドロップを再初期化
        columnManager.initializeDragDrop(tableContainer, (columns) => {
            console.log('列順序が変更されました:', columns);
            updateTable();
            // パネルが開いている場合は更新
            const panel = document.querySelector('.column-settings-panel');
            if (panel && !panel.classList.contains('hidden')) {
                updateColumnSettingsPanel(panel);
            }
        });
        // ColumnManagerで生成されたdata-linkはルーターが自動処理するため、
        // 追加のイベントリスナー設定は不要
    }
}
/**
 * 指定されたデータでテーブルを更新する関数
 */
function updateTableWithData(data) {
    const tableContainer = document.querySelector('.table-container table');
    if (tableContainer && columnManager) {
        const tableHTML = columnManager.generateTableHTML(data);
        tableContainer.innerHTML = tableHTML;
        // ドラッグアンドドロップを再初期化
        columnManager.initializeDragDrop(tableContainer, (columns) => {
            console.log('列順序が変更されました:', columns);
            updateTable();
            // パネルが開いている場合は更新
            const panel = document.querySelector('.column-settings-panel');
            if (panel && !panel.classList.contains('hidden')) {
                updateColumnSettingsPanel(panel);
            }
        });
        // ColumnManagerで生成されたdata-linkはルーターが自動処理するため、
        // 追加のイベントリスナー設定は不要
    }
}
/**
 * テーブル行のHTMLを生成する関数（後方互換性のため残す）
 */
function generateTableRows(filteredData) {
    // ColumnManagerが利用可能な場合はそれを使用
    if (columnManager) {
        const dataToUse = filteredData || projectData;
        return columnManager.generateTableHTML(dataToUse);
    }
    // フォールバック: 従来の方法
    let rows = "";
    const dataToUse = filteredData || projectData;
    dataToUse.forEach(project => {
        const projectData = getData(project.projectNo);
        const href = generateProjectRoute(projectData.businessType, project.projectNo);
        rows += `
      <tr>
        <td><a href="${href}" data-link data-project-id="${project.projectNo}">${project.projectNo}</a></td>
        <td>${project.storeNo}</td>
        <td>${project.storeName}</td>
        <td>${project.zoName}</td>
        <td>${project.doName}</td>
        <td>${project.contractType}</td>
        <td>${project.ownershipType}</td>
        <td>${project.businessType}</td>
        <td>${project.programName}</td>
        <td>${project.projectStatus}</td>
        <td>${project.progressStatus}</td>
        <td>${project.startDate}</td>
        <td>${project.ofcName}</td>
        <td>${project.applicationType}</td>
        <td>${project.equipMantePlanCont}</td>
        <td>${project.airConditioningMantePlanCont}</td>
        <td>${project.sevenCafeMantePlanCont}</td>
        <td>${project.fryerMantePlanCont}</td>
        <td>${project.dishwasherMantePlanCont}</td>
        <td>${project.smoothieEquipMantePlanCont}</td>
        <td>${project.automaticDoorManteCont}</td>
        <td>${project.storefrontSignMantePlanCont}</td>
        <td>${project.signPoleMantePlanCont}</td>
      </tr>
    `;
    });
    return rows;
}
/**
 * 店No：単一完全一致（テキスト入力）定型チェック（定型がある）
 */
function checkSearchStoreNo() {
    // 店No入力フィールドから値を取得
    const storeNoInput = document.getElementById('店No');
    const storeNoValue = storeNoInput ? storeNoInput.value.trim() : '';
    console.log('検索する店No:', storeNoValue);
    // 店番の6桁チェック処理と正規化
    let normalizedStoreNo = storeNoValue;
    if (storeNoValue !== '') {
        // 全角数字を半角数字に変換
        normalizedStoreNo = storeNoValue.replace(/[０-９]/g, (match) => {
            return String.fromCharCode(match.charCodeAt(0) - 0xFEE0);
        });
        // 半角数字6桁のチェック
        const storeNoPattern = /^\d{6}$/;
        if (!storeNoPattern.test(normalizedStoreNo)) {
            showPopupAlert({
                text: '店番は半角数字または全角数字で6桁で入力してください。',
                showBackdrop: true
            });
            return '';
        }
        console.log('正規化された店No:', normalizedStoreNo);
    }
    return normalizedStoreNo;
}
/**
 * 店名：あいまい検索（テキスト入力＋データも定型ではないため）入力チェックなし（XXSチェック他必須系はする）
 */
function checkSearchStoreName() {
    const storeNameInput = document.getElementById('店名');
    const storeNameValue = storeNameInput ? storeNameInput.value.trim() : '';
    console.log('検索する店名:', storeNameValue);
    // 店番の6桁チェック処理と正規化
    let normalizedStoreName = storeNameValue;
    if (storeNameValue !== '') {
        console.log('正規化された店名:', normalizedStoreName);
    }
    return normalizedStoreName;
}
/**
 * OFC名：あいまい検索（テキスト入力＋データも定型ではないため）入力チェックなし（XXSチェック他必須系はする）
 */
function checkSearchOfcName() {
    const ofcNameInput = document.getElementById('OFC名');
    const ofcNameValue = ofcNameInput ? ofcNameInput.value.trim() : '';
    console.log('検索するOFC名:', ofcNameValue);
    // 店番の6桁チェック処理と正規化
    let normalizedOfcName = ofcNameValue;
    if (ofcNameValue !== '') {
        console.log('正規化されたOFC名:', normalizedOfcName);
    }
    return normalizedOfcName;
}
/**
 * 案件No：前方一致（テキスト入力）定型チェック（多分定型がある）
 */
function checkSearchProjectNo() {
    const projectNoInput = document.getElementById('案件No');
    const projectNoValue = projectNoInput ? projectNoInput.value.trim() : '';
    console.log('検索する案件No:', projectNoValue);
    let normalizedProjectNo = projectNoValue;
    if (projectNoValue !== '') {
        // 全角英数字を半角に変換
        normalizedProjectNo = projectNoValue.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (match) => {
            return String.fromCharCode(match.charCodeAt(0) - 0xFEE0);
        });
        // STから始まる半角数字4桁のチェック
        const projectNoPattern = /^ST\d{4}$/;
        if (!projectNoPattern.test(normalizedProjectNo)) {
            // showPopupAlert('案件Noは「ST」から始まる半角数字4桁で入力してください。');
            // return '';
        }
        console.log('正規化された案件No:', normalizedProjectNo);
    }
    return normalizedProjectNo;
}
/**
 * 業務種別：単一完全一致（ドロップメニューのため）
 */
function checkSearchBusinessType() {
    const businessTypeInput = document.getElementById('業務種別');
    const businessTypeValue = businessTypeInput ? businessTypeInput.value.trim() : '';
    console.log('検索する業務種別:', businessTypeValue);
    // 店番の6桁チェック処理と正規化
    let normalizedBusinessType = businessTypeValue;
    if (businessTypeValue !== '') {
        console.log('正規化された業務種別:', normalizedBusinessType);
    }
    return normalizedBusinessType;
}
/**
 * プログラム名：あいまい検索（テキスト入力＋データも定型ではないため）入力チェックなし（XXSチェック他必須系はする）
 */
function checkSearchProgramName() {
    const programNameInput = document.getElementById('プログラム名');
    const programNameValue = programNameInput ? programNameInput.value.trim() : '';
    console.log('検索するプログラム名:', programNameValue);
    // 店番の6桁チェック処理と正規化
    let normalizedProgramName = programNameValue;
    if (programNameValue !== '') {
        console.log('正規化されたプログラム名:', normalizedProgramName);
    }
    return normalizedProgramName;
}
/**
 * 案件状況：単一完全一致（ドロップメニューのため）
 */
function checkSearchProjectStatus() {
    const projectStatusInput = document.getElementById('案件状況');
    const projectStatusValue = projectStatusInput ? projectStatusInput.value.trim() : '';
    console.log('検索する案件状況:', projectStatusValue);
    // 店番の6桁チェック処理と正規化
    let normalizedProjectStatus = projectStatusValue;
    if (projectStatusValue !== '') {
        console.log('正規化された案件状況:', normalizedProjectStatus);
    }
    return normalizedProjectStatus;
}
/**
 * ステータス：単一完全一致（ドロップメニューのため）
 */
function checkSearchStatus() {
    const statusInput = document.getElementById('ステータス');
    const statusValue = statusInput ? statusInput.value.trim() : '';
    console.log('検索するステータス:', statusValue);
    let normalizedStatus = statusValue;
    if (statusValue !== '') {
        console.log('正規化されたステータス:', normalizedStatus);
    }
    return normalizedStatus;
}
/**
 * 案件開始日（From）：FromToの期間検索
 */
function checkSearchProjectFrom() {
    const projectFromInput = document.getElementById('inputProjectFrom');
    const projectFromValue = projectFromInput ? projectFromInput.value.trim() : '';
    console.log('検索する案件開始日（From）:', projectFromValue);
    // 日付形式をYYYY-MM-DDからYYYYMMDDに変換（BEの期待形式）
    let normalizedProjectFrom = projectFromValue;
    if (projectFromValue !== '') {
        normalizedProjectFrom = projectFromValue.replace(/-/g, '');
        console.log('正規化された案件開始日（From）:', normalizedProjectFrom);
    }
    return normalizedProjectFrom;
}
/**
 * 案件開始日（To）：FromToの期間検索
 */
function checkSearchProjectTo() {
    const projectFromInput = document.getElementById('inputProjectFrom');
    const projectFromValue = projectFromInput ? projectFromInput.value.trim() : '';
    const projectToInput = document.getElementById('inputProjectTo');
    const projectToValue = projectToInput ? projectToInput.value.trim() : '';
    console.log('検索する案件開始日（To）:', projectToValue);
    // 日付形式をYYYY-MM-DDからYYYYMMDDに変換（BEの期待形式）
    let normalizedProjectTo = projectToValue;
    if (projectToValue !== '') {
        normalizedProjectTo = projectToValue.replace(/-/g, '');
        console.log('正規化された案件開始日（To）:', normalizedProjectTo);
        if (projectFromValue !== '') {
            if (projectToValue < projectFromValue) {
                showPopupAlert({
                    text: '案件開始日（From）は案件開始日（To）以前にしてください。',
                    showBackdrop: true
                });
                return '';
            }
        }
    }
    return normalizedProjectTo;
}
/**
 * DO名：単一完全一致（ドロップダウンのため）
 */
function checkSearchDoName() {
    const doNameInput = document.getElementById('inputDoName');
    const doNameValue = doNameInput ? doNameInput.value.trim() : '';
    console.log('検索するDO名:', doNameValue);
    return doNameValue;
}
/**
 * ZO名：単一完全一致（ドロップダウンのため）
 */
function checkSearchZoName() {
    const zoNameInput = document.getElementById('inputZoName');
    const zoNameValue = zoNameInput ? zoNameInput.value.trim() : '';
    console.log('検索するZO名:', zoNameValue);
    return zoNameValue;
}
/**
 * 検索条件をセッションストレージに保存する関数
 */
function saveSearchConditionsToSession() {
    const searchConditions = {
        storeNo: document.getElementById('店No')?.value || '',
        storeName: document.getElementById('店名')?.value || '',
        ofcName: document.getElementById('OFC名')?.value || '',
        projectNo: document.getElementById('案件No')?.value || '',
        programName: document.getElementById('プログラム名')?.value || '',
        businessType: document.getElementById('業務種別')?.value || '',
        projectStatus: document.getElementById('案件状況')?.value || '',
        status: document.getElementById('ステータス')?.value || '',
        zoName: document.getElementById('inputZoName')?.value || '',
        doName: document.getElementById('inputDoName')?.value || '',
        projectFrom: document.getElementById('inputProjectFrom')?.value || '',
        projectTo: document.getElementById('inputProjectTo')?.value || ''
    };
    sessionStorage.setItem('projectSearchConditions', JSON.stringify(searchConditions));
    console.log('検索条件をセッションストレージに保存しました:', searchConditions);
}
/**
 * セッションストレージから検索条件を復元する関数
 */
function loadSearchConditionsFromSession() {
    const savedConditions = sessionStorage.getItem('projectSearchConditions');
    if (!savedConditions) {
        console.log('保存された検索条件がありません');
        return;
    }
    try {
        const conditions = JSON.parse(savedConditions);
        console.log('セッションストレージから検索条件を復元します:', conditions);
        // テキスト入力フィールドを復元
        const textFields = [
            { id: '店No', value: conditions.storeNo },
            { id: '店名', value: conditions.storeName },
            { id: 'OFC名', value: conditions.ofcName },
            { id: '案件No', value: conditions.projectNo },
            { id: 'プログラム名', value: conditions.programName }
        ];
        textFields.forEach(({ id, value }) => {
            const input = document.getElementById(id);
            if (input && value) {
                input.value = value;
            }
        });
        // セレクトボックスを復元
        const selectFields = [
            { id: '業務種別', value: conditions.businessType },
            { id: '案件状況', value: conditions.projectStatus },
            { id: 'ステータス', value: conditions.status },
            { id: 'inputZoName', value: conditions.zoName },
            { id: 'inputDoName', value: conditions.doName }
        ];
        selectFields.forEach(({ id, value }) => {
            const select = document.getElementById(id);
            if (select && value) {
                select.value = value;
            }
        });
        // 日付入力フィールドを復元
        const dateFields = [
            { id: 'inputProjectFrom', value: conditions.projectFrom },
            { id: 'inputProjectTo', value: conditions.projectTo }
        ];
        dateFields.forEach(({ id, value }) => {
            const input = document.getElementById(id);
            if (input && value) {
                input.value = value;
            }
        });
        console.log('検索条件の復元が完了しました');
    }
    catch (error) {
        console.error('検索条件の復元に失敗しました:', error);
    }
}
/**
 * セッションストレージから検索条件を削除する関数
 */
function clearSearchConditionsFromSession() {
    sessionStorage.removeItem('projectSearchConditions');
    console.log('セッションストレージから検索条件を削除しました');
}
/**
 * 検索条件をクリアする関数
 */
function clearSearchConditions() {
    console.log('検索条件をクリアします');
    // テキスト入力フィールドをクリア
    const textInputs = [
        '店No',
        '店名',
        'OFC名',
        '案件No',
        'プログラム名'
    ];
    textInputs.forEach(id => {
        const input = document.getElementById(id);
        if (input) {
            input.value = '';
        }
    });
    // セレクトボックスをクリア（初期値に戻す）
    const selectInputs = [
        { id: '業務種別', defaultValue: '' },
        { id: '案件状況', defaultValue: '' },
        { id: 'ステータス', defaultValue: '' }
    ];
    selectInputs.forEach(({ id, defaultValue }) => {
        const select = document.getElementById(id);
        if (select) {
            select.value = defaultValue;
        }
    });
    // 動的に生成されるZO名・DO名のセレクトボックスは selectedIndex で先頭に戻す
    const dynamicSelects = ['inputZoName', 'inputDoName'];
    dynamicSelects.forEach(id => {
        const select = document.getElementById(id);
        if (select) {
            select.selectedIndex = 0;
        }
    });
    // 日付入力フィールドをクリア
    const dateInputs = [
        'inputProjectFrom',
        'inputProjectTo'
    ];
    dateInputs.forEach(id => {
        const input = document.getElementById(id);
        if (input) {
            input.value = '';
        }
    });
    // セッションストレージからも削除
    clearSearchConditionsFromSession();
    console.log('検索条件をクリアしました');
}
/**
 * 検索を実行する関数
 */
async function performSearch(page = 1) {
    console.log('検索処理を開始します', `ページ: ${page}`);
    let normalizedStoreNo = checkSearchStoreNo();
    let normalizedStoreName = checkSearchStoreName();
    let normalizedZoName = checkSearchZoName();
    let normalizedDoName = checkSearchDoName();
    let normalizedOfcName = checkSearchOfcName();
    let normalizedProjectNo = checkSearchProjectNo();
    let normalizedBusinessType = checkSearchBusinessType();
    let normalizedProgramName = checkSearchProgramName();
    let normalizedProjectStatus = checkSearchProjectStatus();
    let normalizedStatus = checkSearchStatus();
    let normalizedProjectFrom = checkSearchProjectFrom();
    let normalizedProjectTo = checkSearchProjectTo();
    // バリデーションエラー判定：入力値があるのにチェック結果が空 = エラー発生
    const storeNoInput = document.getElementById('店No');
    if (storeNoInput?.value.trim() !== '' && normalizedStoreNo === '')
        return;
    const projectToInput = document.getElementById('inputProjectTo');
    if (projectToInput?.value.trim() !== '' && normalizedProjectTo === '')
        return;
    const apiParam = {
        tenpoNo: normalizedStoreNo,
        tenpoName: normalizedStoreName,
        zoCode: "",
        zoName: normalizedZoName,
        doCode: "",
        doName: normalizedDoName,
        ofcName: normalizedOfcName,
        projectNo: normalizedProjectNo,
        businessType: normalizedBusinessType,
        programName: normalizedProgramName,
        projectStatus: normalizedProjectStatus,
        status: normalizedStatus,
        progressStatus: "", // 後方互換性のため保持
        startDateFrom: normalizedProjectFrom, // 案件開始日（From）
        startDateTo: normalizedProjectTo, // 案件開始日（To）
        page: page,
        pageSize: DEFAULT_PAGE_SIZE,
        columnPattern: "minimal" // 列最小化パターン（14カラムのみ取得）
    };
    // POST通信を実行（指定されたfetchの例と同様の通信）
    try {
        // APIレスポンス成功後、ProjectDataのJSONを表示
        console.log('=== loadProjectDataFromApi の内容を表示 ===');
        const response = await loadProjectDataFromApi(apiParam);
        console.log('ProjectData JSON:', JSON.stringify(response.projects));
        console.log('ProjectData 件数:', response.projects.length);
        console.log('ページング情報:', response.pagination);
        // グローバル変数を更新
        projectData = response.projects;
        paginationInfo = response.pagination;
        // 検索条件をセッションストレージに保存
        saveSearchConditionsToSession();
        // テーブルを更新
        updateTableWithData(response.projects);
        console.log('テーブルをProjectDataで更新しました');
        // ページング情報を更新
        updatePaginationDisplay();
    }
    catch (error) {
        console.error('POST通信エラー:', error);
        // エラーの場合は従来通りの処理
        let filteredData;
        if (normalizedStoreNo === '') {
            filteredData = projectData;
            console.log('エラー時: 検索条件が空のため、全データを表示します');
        }
        else {
            filteredData = projectData.filter(project => project.storeNo.includes(normalizedStoreNo));
            console.log(`エラー時: 検索結果: ${filteredData.length}件見つかりました`);
        }
        const generateTableRowsElement = document.getElementById('generateTableRows');
        if (generateTableRowsElement) {
            generateTableRowsElement.innerHTML = generateTableRows(filteredData);
            setProjectLinkListeners();
            console.log('エラー時: テーブルを更新しました');
        }
    }
}
/**
 * ページング表示を更新する関数
 */
function updatePaginationDisplay() {
    // ページング情報表示エリアを取得（HTMLで既に作成済み）
    let paginationArea = document.getElementById('paginationArea');
    if (paginationArea) {
        paginationArea.innerHTML = `
      <div class="pagination-controls">
        <button class="pagination-btn pagination-prev" ${!paginationInfo.hasPrevious ? 'disabled' : ''}
                ${!paginationInfo.hasPrevious ? 'style="opacity:0.5;cursor:not-allowed;"' : ''}>
          <span class="material-icons">chevron_left</span>
        </button>
        <input type="text" class="pagination-input" id="currentPageInput" value="${paginationInfo.page}" />
        <span class="pagination-separator">/</span>
        <span class="pagination-total">${paginationInfo.totalPages}</span>
        <button class="pagination-btn pagination-next" ${!paginationInfo.hasNext ? 'disabled' : ''}
                ${!paginationInfo.hasNext ? 'style="opacity:0.5;cursor:not-allowed;"' : ''}>
          <span class="material-icons">chevron_right</span>
        </button>
      </div>
    `;
        // ページングボタンのイベントリスナーを設定
        setupPaginationButtonListeners();
        // ページ番号入力フィールドのイベントリスナーを設定
        setupPageInputListener();
    }
}
/**
 * ページングボタンのイベントリスナーを設定する関数
 */
function setupPaginationButtonListeners() {
    // 前へボタン
    const prevButton = document.querySelector('.pagination-prev');
    if (prevButton && !prevButton.disabled) {
        prevButton.addEventListener('click', () => {
            goToPage(paginationInfo.page - 1);
        });
    }
    // 次へボタン
    const nextButton = document.querySelector('.pagination-next');
    if (nextButton && !nextButton.disabled) {
        nextButton.addEventListener('click', () => {
            goToPage(paginationInfo.page + 1);
        });
    }
}
/**
 * ページ番号入力フィールドのイベントリスナーを設定する関数
 */
function setupPageInputListener() {
    const pageInput = document.getElementById('currentPageInput');
    if (pageInput) {
        pageInput.addEventListener('change', (e) => {
            const target = e.target;
            let inputValue = target.value.trim();
            // 全角数字を半角数字に変換
            inputValue = inputValue.replace(/[０-９]/g, (match) => {
                return String.fromCharCode(match.charCodeAt(0) - 0xFEE0);
            });
            const inputPage = parseInt(inputValue, 10);
            // 入力値の検証
            if (isNaN(inputPage)) {
                showPopupAlert({
                    text: 'ページ番号は数字で入力してください。',
                    showBackdrop: true
                });
                target.value = paginationInfo.page.toString();
                return;
            }
            if (inputPage < 1) {
                showPopupAlert({
                    text: 'ページ番号は1以上で入力してください。',
                    showBackdrop: true
                });
                target.value = paginationInfo.page.toString();
                return;
            }
            if (inputPage > paginationInfo.totalPages) {
                showPopupAlert({
                    text: `ページ番号は${paginationInfo.totalPages}以下で入力してください。`,
                    showBackdrop: true
                });
                target.value = paginationInfo.page.toString();
                return;
            }
            // 有効なページ番号の場合は移動
            goToPage(inputPage);
        });
        // Enterキーでも移動できるようにする
        pageInput.addEventListener('keypress', (e) => {
            if (e.key === 'Enter') {
                pageInput.blur(); // フォーカスを外してchangeイベントを発火
            }
        });
    }
}
/**
 * 指定ページに移動する関数
 */
function goToPage(page) {
    if (page >= 1 && page <= paginationInfo.totalPages) {
        performSearch(page);
    }
}
/**
 * 案件詳細リンクのイベントリスナーを設定する関数
 */
function setProjectLinkListeners() {
    // 既存のイベントリスナーを削除してから新しいものを設定
    const projectLinks = document.querySelectorAll('table tbody tr td:first-child a');
    projectLinks.forEach(link => {
        // 既存のイベントリスナーをクリア
        const newLink = link.cloneNode(true);
        link.parentNode?.replaceChild(newLink, link);
        // 新しいイベントリスナーを設定
        newLink.addEventListener('click', (e) => {
            e.preventDefault();
            const projectId = newLink.textContent;
            if (projectId) {
                const projectData = getData(projectId);
                // ルーターを使用してナビゲーション
                navigate(generateProjectRoute(projectData.businessType, projectId));
            }
        });
    });
}
/**
 * ボタンにイベントリスナーを設定する関数
 */
function setButtons() {
    console.log('setButtons関数が呼び出されました');
    try {
        // 検索ボタン
        const searchButton = document.getElementById('searchButton');
        console.log('検索ボタン要素:', searchButton);
        if (searchButton) {
            searchButton.addEventListener('click', () => {
                console.log('検索ボタンがクリックされました');
                performSearch();
            });
            console.log('検索ボタンにイベントリスナーを設定しました');
        }
        else {
            console.error('検索ボタンが見つかりません');
        }
        // クリアボタン
        const clearButton = document.getElementById('clearButton');
        console.log('クリアボタン要素:', clearButton);
        if (clearButton) {
            clearButton.addEventListener('click', () => {
                console.log('クリアボタンがクリックされました');
                clearSearchConditions();
            });
            console.log('クリアボタンにイベントリスナーを設定しました');
        }
        else {
            console.error('クリアボタンが見つかりません');
        }
        // マニュアルリンク
        const manualLink = document.querySelector('a.board-link-button');
        console.log('マニュアルリンク要素:', manualLink);
        if (manualLink) {
            manualLink.addEventListener('click', (e) => {
                console.log('マニュアルリンクがクリックされました');
                e.preventDefault();
                showPopupAlert({
                    text: '現在マニュアルは作成中です',
                    showBackdrop: true
                });
            });
            console.log('マニュアルリンクにイベントリスナーを設定しました');
        }
        else {
            console.error('マニュアルリンクが見つかりません');
        }
        // CSV出力ボタン
        const csvButton = document.getElementById('csvButton');
        console.log('CSV出力ボタン要素:', csvButton);
        if (csvButton) {
            csvButton.addEventListener('click', () => {
                console.log('CSV出力ボタンがクリックされました');
                exportProjectDataToCsv();
            });
            console.log('CSV出力ボタンにイベントリスナーを設定しました');
        }
        else {
            console.error('CSV出力ボタンが見つかりません');
        }
        // 列設定ボタン
        const columnSettingsButton = document.querySelector('button.column-settings-button');
        if (columnSettingsButton) {
            columnSettingsButton.addEventListener('click', toggleColumnSettingsPanel);
            console.log('列設定ボタンにイベントリスナーを設定しました');
        }
        else {
            console.error('列設定ボタンが見つかりません');
        }
        // ColumnManagerで生成されたdata-linkはルーターが自動処理するため、
        // 追加のイベントリスナー設定は不要
        console.log('案件詳細リンクはルーターが自動処理します');
    }
    catch (error) {
        console.error('イベントリスナー設定中にエラーが発生しました:', error);
    }
}
function getData(projectId) {
    for (let project of projectData) {
        if (project.projectNo === projectId) {
            return project;
        }
    }
    ;
    return {
        projectNo: "",
        storeNo: "",
        storeName: "",
        zoName: "",
        doName: "",
        contractType: "",
        ownershipType: "",
        businessType: "",
        programName: "",
        projectStatus: "",
        progressStatus: "",
        startDate: "",
        ofcName: "",
        applicationType: "",
        equipMantePlanCont: "",
        airConditioningMantePlanCont: "",
        sevenCafeMantePlanCont: "",
        fryerMantePlanCont: "",
        dishwasherMantePlanCont: "",
        smoothieEquipMantePlanCont: "",
        automaticDoorManteCont: "",
        storefrontSignMantePlanCont: "",
        signPoleMantePlanCont: ""
    };
}
/**
 * 店舗リストの初期化
 */
export const initializeDataList = async () => {
    console.log('=== initializeDataList 開始 ===');
    try {
        // ColumnManagerを初期化
        columnManager = new ColumnManager();
        // データが未初期化の場合は初期化を行う
        if (projectData.length === 0) {
            console.log('データ未初期化のため、UI初期化を実行します');
            // ローディング表示を開始
            startLoadingDisplay();
            console.log('ローディング表示を開始しました');
            // UI初期化のみ実行（データ取得はperformSearchで行う）
            console.log('並列API呼び出しを開始します');
            const [, , storeListContent, userInfo] = await Promise.all([
                loadZoDataFromApi(),
                loadDoDataFromApi(),
                getHtml("/parts/storeList.html"),
                getUserInformationCached(false) // isLoading=falseで個別ローディングを無効化
            ]);
            console.log('並列API呼び出しが完了しました');
            // 空のデータで初期化（performSearchで上書きされる）
            projectData = [];
            paginationInfo = {
                page: 1,
                pageSize: DEFAULT_PAGE_SIZE,
                totalRecords: 0,
                totalPages: 0,
                hasNext: false,
                hasPrevious: false
            };
            // ユーザー情報を使用してColumnManagerとHeaderを初期化（共有使用）
            columnManager.loadUserSettingsFromUserInfo(userInfo);
            const subContents = document.getElementById('subContents');
            if (storeListContent) {
                // 案件一覧画面のHTMLを生成
                subContents.innerHTML = storeListContent;
            }
            initializeHeaderWithUserInfo(userInfo);
        }
        else {
            console.log('データ既存のため、UI初期化のみ実行します');
            // ローディング表示を開始
            startLoadingDisplay();
            console.log('ローディング表示を開始しました');
            // データが既に存在する場合はUI初期化のみ実行
            const [storeListContent, userInfo] = await Promise.all([
                getHtml("/parts/storeList.html"),
                getUserInformationCached(false) // isLoading=falseで個別ローディングを無効化
            ]);
            columnManager.loadUserSettingsFromUserInfo(userInfo);
            const subContents = document.getElementById('subContents');
            if (storeListContent) {
                subContents.innerHTML = storeListContent;
            }
            initializeHeaderWithUserInfo(userInfo);
        }
        console.log('テーブル初期化を開始します');
        // ColumnManagerを使用してテーブルを生成
        await initializeTable();
        console.log('ページング表示を更新します');
        // 初期のページング表示を更新
        updatePaginationDisplay();
        console.log('ボタンイベントを設定します');
        // ボタンにイベントリスナーを設定
        setButtons();
        // ZO名、DO名のドロップダウンリストを設定
        console.log('ZO名、DO名のドロップダウンリストを設定します');
        await setSelectZo();
        await setSelectDo();
        console.log('ZO名、DO名のドロップダウンリストを設定しました');
        // ドロップダウン設定後に検索条件を復元
        loadSearchConditionsFromSession();
        // データが未初期化の場合は検索を実行（検索条件があればその条件で、なければ全件取得）
        if (projectData.length === 0) {
            console.log('データ未初期化のため、検索を実行します');
            await performSearch();
        }
        console.log('ローディング表示を終了します');
        // ローディング表示を終了
        endLoadingDisplay();
        console.log('=== initializeDataList 完了 ===');
    }
    catch (error) {
        console.error('=== initializeDataList でエラーが発生しました ===', error);
        // エラーが発生した場合もローディングを終了
        endLoadingDisplay();
        throw error;
    }
};
